// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sm1yNzLnpvAIYIBwrQnF {
  backdrop-filter: blur(4px);
  border: 1px solid #3B3D42;
  background: rgba(30, 30, 30, 0.8);
  -webkit-backdrop-filter: blur(4px);
  border-radius: 8px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  color: white;
  font-family: Arial, sans-serif;
  height: 48px;
  min-height: 48px;
  transition: transform 0.5s ease-in-out;
}
.Sm1yNzLnpvAIYIBwrQnF[data-hide='true'] {
  transform: translateX(110%) translateZ(0);
}
/* Mobile portrait - almost full width with 8px padding on sides; shrinks below 360px (name ellipsises) */
@media (max-width: 1023px) and (orientation: portrait) {
  .Sm1yNzLnpvAIYIBwrQnF {
    width: 360px;
    min-width: 200px;
  }
}
/* Mobile landscape - fixed width, positioned on left */
@media (max-width: 1023px) and (orientation: landscape) {
  .Sm1yNzLnpvAIYIBwrQnF {
    width: 360px;
    min-width: 360px;
  }
}
/* Desktop */
@media (min-width: 1024px) {
  .Sm1yNzLnpvAIYIBwrQnF {
    width: 540px;
    height: 72px;
    min-width: 540px;
    min-height: 72px;
  }
}
.miJoLMGFOFwG3QYKppSL {
  display: flex;
  align-items: center;
  flex: 1;
  gap: 8px;
  padding-left: 4px;
  min-width: 0;
}
@media (min-width: 1024px) {
  .miJoLMGFOFwG3QYKppSL {
    gap: 6px;
    padding-left: 6px;
  }
}
.E75eIecMTgXWIVRYAG0Q {
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
}
@media (min-width: 1024px) {
  .E75eIecMTgXWIVRYAG0Q {
    width: 54px;
    height: 54px;
    min-width: 54px;
    min-height: 54px;
  }
}
.E75eIecMTgXWIVRYAG0Q img {
  width: 90%;
  height: 100%;
  object-fit: cover;
  object-position: top;
  border-radius: 4px;
}
.pUm29FYHfiSFru24p_ed {
  font-family: var(--font-family-primary);
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  min-width: 0;
  align-items: baseline;
}
.iaTb_AFXza7ApG6dCOL0 {
  font-size: 16px;
  color: #ffffff;
  font-weight: 400;
  line-height: 1.2;
  margin: 0;
}
@media (min-width: 1024px) {
  .iaTb_AFXza7ApG6dCOL0 {
    font-size: 24px;
  }
}
.svjvR7_SN_qoWnOIJUR7 {
  font-size: 18px;
  color: white;
  font-weight: 500;
  line-height: 1.2;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  width: 100%;
}
/* Desktop */
@media (min-width: 1024px) {
  .svjvR7_SN_qoWnOIJUR7 {
    font-size: 27px;
  }
}
.gz4DxQWhmYbKPCy7xn_v {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-right: 8px;
  flex-shrink: 0;
}
@media (min-width: 1024px) {
  .gz4DxQWhmYbKPCy7xn_v {
    gap: 12px;
    padding-right: 12px;
  }
}
.ZmetKFP5D1E9OyL4uiCx {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  width: 28px;
  height: 28px;
  min-width: unset;
  min-height: unset;
}
@media (min-width: 1024px) {
  .ZmetKFP5D1E9OyL4uiCx {
    width: 40px;
    height: 40px;
    min-width: unset;
    min-height: unset;
    padding: 5px;
  }
}
@media (hover: hover) and (pointer: fine) {
  .ZmetKFP5D1E9OyL4uiCx:hover {
    background: rgba(255, 255, 255, 0.1);
  }
}
.ZmetKFP5D1E9OyL4uiCx .RaGoaf66rB9rNhKzbNAy {
  width: 20px;
  height: 20px;
}
@media (min-width: 1024px) {
  .ZmetKFP5D1E9OyL4uiCx .RaGoaf66rB9rNhKzbNAy {
    width: 30px;
    height: 30px;
  }
}
.RaGoaf66rB9rNhKzbNAy {
  display: inline-block;
}
.vyT8W3t5tPN83qXcBHkQ {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  width: 28px;
  height: 28px;
  min-width: unset;
  min-height: unset;
}
@media (min-width: 1024px) {
  .vyT8W3t5tPN83qXcBHkQ {
    width: 40px;
    height: 40px;
    min-width: unset;
    min-height: unset;
    padding: 10px;
  }
}
.vyT8W3t5tPN83qXcBHkQ:hover {
  background: rgba(255, 255, 255, 0.1);
}
.vyT8W3t5tPN83qXcBHkQ img {
  width: 16px;
  height: 16px;
}
@media (min-width: 1024px) {
  .vyT8W3t5tPN83qXcBHkQ img {
    width: 24px;
    height: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/games/components/BackToGameToast/BackToGameToast.module.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,iCAAiC;EACjC,kCAAkC;EAClC,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,yCAAyC;AAC3C;AACA,yGAAyG;AACzG;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;AACA,uDAAuD;AACvD;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;AACA,YAAY;AACZ;EACE;IACE,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,YAAY;AACd;AACA;EACE;IACE,QAAQ;IACR,iBAAiB;EACnB;AACF;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;AACF;AACA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,OAAO;EACP,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;AACA,YAAY;AACZ;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE;IACE,SAAS;IACT,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;EACd;AACF;AACA;EACE;IACE,oCAAoC;EACtC;AACF;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;EACf;AACF;AACA;EACE,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".lobbyBackToGameToast {\n  backdrop-filter: blur(4px);\n  border: 1px solid #3B3D42;\n  background: rgba(30, 30, 30, 0.8);\n  -webkit-backdrop-filter: blur(4px);\n  border-radius: 8px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  color: white;\n  font-family: Arial, sans-serif;\n  height: 48px;\n  min-height: 48px;\n  transition: transform 0.5s ease-in-out;\n}\n.lobbyBackToGameToast[data-hide='true'] {\n  transform: translateX(110%) translateZ(0);\n}\n/* Mobile portrait - almost full width with 8px padding on sides; shrinks below 360px (name ellipsises) */\n@media (max-width: 1023px) and (orientation: portrait) {\n  .lobbyBackToGameToast {\n    width: 360px;\n    min-width: 200px;\n  }\n}\n/* Mobile landscape - fixed width, positioned on left */\n@media (max-width: 1023px) and (orientation: landscape) {\n  .lobbyBackToGameToast {\n    width: 360px;\n    min-width: 360px;\n  }\n}\n/* Desktop */\n@media (min-width: 1024px) {\n  .lobbyBackToGameToast {\n    width: 540px;\n    height: 72px;\n    min-width: 540px;\n    min-height: 72px;\n  }\n}\n.lobbyBackToGameContent {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  gap: 8px;\n  padding-left: 4px;\n  min-width: 0;\n}\n@media (min-width: 1024px) {\n  .lobbyBackToGameContent {\n    gap: 6px;\n    padding-left: 6px;\n  }\n}\n.lobbyGameThumbnail {\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n  min-height: 36px;\n  border-radius: 4px;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n@media (min-width: 1024px) {\n  .lobbyGameThumbnail {\n    width: 54px;\n    height: 54px;\n    min-width: 54px;\n    min-height: 54px;\n  }\n}\n.lobbyGameThumbnail img {\n  width: 90%;\n  height: 100%;\n  object-fit: cover;\n  object-position: top;\n  border-radius: 4px;\n}\n.lobbyGameInfo {\n  font-family: var(--font-family-primary);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex: 1;\n  min-width: 0;\n  align-items: baseline;\n}\n.lobbyContinueLabel {\n  font-size: 16px;\n  color: #ffffff;\n  font-weight: 400;\n  line-height: 1.2;\n  margin: 0;\n}\n@media (min-width: 1024px) {\n  .lobbyContinueLabel {\n    font-size: 24px;\n  }\n}\n.lobbyGameName {\n  font-size: 18px;\n  color: white;\n  font-weight: 500;\n  line-height: 1.2;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: left;\n  width: 100%;\n}\n/* Desktop */\n@media (min-width: 1024px) {\n  .lobbyGameName {\n    font-size: 27px;\n  }\n}\n.lobbyActionButtons {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding-right: 8px;\n  flex-shrink: 0;\n}\n@media (min-width: 1024px) {\n  .lobbyActionButtons {\n    gap: 12px;\n    padding-right: 12px;\n  }\n}\n.lobbyFavoriteBtn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease;\n  width: 28px;\n  height: 28px;\n  min-width: unset;\n  min-height: unset;\n}\n@media (min-width: 1024px) {\n  .lobbyFavoriteBtn {\n    width: 40px;\n    height: 40px;\n    min-width: unset;\n    min-height: unset;\n    padding: 5px;\n  }\n}\n@media (hover: hover) and (pointer: fine) {\n  .lobbyFavoriteBtn:hover {\n    background: rgba(255, 255, 255, 0.1);\n  }\n}\n.lobbyFavoriteBtn .icon {\n  width: 20px;\n  height: 20px;\n}\n@media (min-width: 1024px) {\n  .lobbyFavoriteBtn .icon {\n    width: 30px;\n    height: 30px;\n  }\n}\n.icon {\n  display: inline-block;\n}\n.lobbyCloseBtn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 20%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s ease;\n  width: 28px;\n  height: 28px;\n  min-width: unset;\n  min-height: unset;\n}\n@media (min-width: 1024px) {\n  .lobbyCloseBtn {\n    width: 40px;\n    height: 40px;\n    min-width: unset;\n    min-height: unset;\n    padding: 10px;\n  }\n}\n.lobbyCloseBtn:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n.lobbyCloseBtn img {\n  width: 16px;\n  height: 16px;\n}\n@media (min-width: 1024px) {\n  .lobbyCloseBtn img {\n    width: 24px;\n    height: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lobbyBackToGameToast": `Sm1yNzLnpvAIYIBwrQnF`,
	"lobbyBackToGameContent": `miJoLMGFOFwG3QYKppSL`,
	"lobbyGameThumbnail": `E75eIecMTgXWIVRYAG0Q`,
	"lobbyGameInfo": `pUm29FYHfiSFru24p_ed`,
	"lobbyContinueLabel": `iaTb_AFXza7ApG6dCOL0`,
	"lobbyGameName": `svjvR7_SN_qoWnOIJUR7`,
	"lobbyActionButtons": `gz4DxQWhmYbKPCy7xn_v`,
	"lobbyFavoriteBtn": `ZmetKFP5D1E9OyL4uiCx`,
	"icon": `RaGoaf66rB9rNhKzbNAy`,
	"lobbyCloseBtn": `vyT8W3t5tPN83qXcBHkQ`
};
export default ___CSS_LOADER_EXPORT___;
